import { Component, inject, Input } from '@angular/core';

import { PaginationService } from '../pagination.service';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {

  paginationService = inject(PaginationService);

  @Input()
  active: string;
}
